class MegaMenuFeaturedSubmenu {
  constructor(root) {
    this.root = root;
    this.listWrap = root.querySelector('.mega-menu-featured__list-wrap') || root;
    this.hoverTimer = null;
    this.triggerType = this.resolveTriggerType();
    this.onClick = this.onClick.bind(this);
    this.onParentToggle = this.onParentToggle.bind(this);
    this.onWrapEnter = this.onWrapEnter.bind(this);
    this.onWrapLeave = this.onWrapLeave.bind(this);

    this.root.addEventListener('click', this.onClick);

    if (this.triggerType === 'hover') {
      this.root.classList.add('mega-menu-featured--submenu-hover');
      this.listWrap.querySelectorAll('.mega-menu-featured__list-item-wrap').forEach((wrap) => {
        if (!wrap.querySelector(':scope > [data-featured-submenu-open]')) return;
        wrap.addEventListener('mouseenter', this.onWrapEnter);
        wrap.addEventListener('mouseleave', this.onWrapLeave);
      });
    }

    const parentDetails = this.root.closest('.nav-item')?.querySelector(
      ':scope > header-menu-trigger > details'
    );
    parentDetails?.addEventListener('toggle', this.onParentToggle);
  }

  resolveTriggerType() {
    const setting = this.root.getAttribute('data-submenu-trigger') || 'hover';
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (setting === 'hover' && canHover) return 'hover';
    return 'click';
  }

  getOpenTrigger(wrap) {
    return wrap?.querySelector(':scope > [data-featured-submenu-open]') || null;
  }

  getSubmenu(openTrigger) {
    const submenu = openTrigger?.nextElementSibling;
    if (!submenu?.matches('[data-featured-submenu]')) return null;
    return submenu;
  }

  openSubmenu(openTrigger) {
    const submenu = this.getSubmenu(openTrigger);
    if (!submenu) return;

    const parentPanel = openTrigger.closest('[data-featured-submenu]');
    const scope = parentPanel || this.listWrap;

    scope.querySelectorAll('[data-featured-submenu].is-active').forEach((active) => {
      if (active === submenu || submenu.contains(active) || active.contains(submenu)) return;
      active.classList.remove('is-active');
      active.previousElementSibling?.setAttribute('aria-expanded', 'false');
    });

    submenu.classList.add('is-active');
    this.listWrap.classList.add('has-active-submenu');
    openTrigger.setAttribute('aria-expanded', 'true');
  }

  closeSubmenu(submenu) {
    if (!submenu) return;

    submenu.querySelectorAll('[data-featured-submenu].is-active').forEach((nestedSubmenu) => {
      nestedSubmenu.classList.remove('is-active');
      nestedSubmenu.previousElementSibling?.setAttribute('aria-expanded', 'false');
    });
    submenu.classList.remove('is-active');
    submenu.previousElementSibling?.setAttribute('aria-expanded', 'false');

    if (!this.listWrap.querySelector('[data-featured-submenu].is-active')) {
      this.listWrap.classList.remove('has-active-submenu');
    }
  }

  onClick(event) {
    const openTrigger = event.target.closest('[data-featured-submenu-open]');
    if (openTrigger && this.root.contains(openTrigger)) {
      event.preventDefault();
      event.stopPropagation();
      this.openSubmenu(openTrigger);
      return;
    }

    const closeTrigger = event.target.closest('[data-featured-submenu-close]');
    if (!closeTrigger || !this.root.contains(closeTrigger)) return;

    event.preventDefault();
    event.stopPropagation();
    this.closeSubmenu(closeTrigger.closest('[data-featured-submenu]'));
  }

  onWrapEnter(event) {
    const wrap = event.currentTarget;
    const openTrigger = this.getOpenTrigger(wrap);
    if (!openTrigger) return;

    clearTimeout(this.hoverTimer);
    this.hoverTimer = setTimeout(() => {
      this.openSubmenu(openTrigger);
    }, 80);
  }

  onWrapLeave(event) {
    const wrap = event.currentTarget;
    if (wrap.contains(event.relatedTarget)) return;

    const openTrigger = this.getOpenTrigger(wrap);
    const submenu = this.getSubmenu(openTrigger);
    if (!submenu) return;

    clearTimeout(this.hoverTimer);
    this.hoverTimer = setTimeout(() => {
      this.closeSubmenu(submenu);
    }, 80);
  }

  closeAllSubmenus() {
    clearTimeout(this.hoverTimer);
    this.root.querySelectorAll('[data-featured-submenu].is-active').forEach((submenu) => {
      submenu.classList.remove('is-active');
    });
    this.root.querySelectorAll('[data-featured-submenu-open]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
    this.listWrap.classList.remove('has-active-submenu');
  }

  onParentToggle(event) {
    if (!event.target.open) {
      this.closeAllSubmenus();
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.mega-menu-featured').forEach((root) => {
    new MegaMenuFeaturedSubmenu(root);
  });
});
